import { type AggregationFn } from "@tanstack/react-table";

export const empty: AggregationFn<unknown> = (columnId, leafRows) => {
	let count = 0;
	leafRows.forEach((row) => {
		const value = row.getValue(columnId);
		if (value === null || value === "" || value === undefined) {
			count += 1;
		}
	});

	return count;
};
